/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import AmountToWords from "../../../../components/_utils/AmountToWords";
import CommonAlertCard from "../../../../components/_utils/CommonAlertCard/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import Loader from "../../../../components/Loader/Index.jsx";
import BeneficiaryTransactionStepAccount from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionCreate/BeneficiaryTransactionStepAccount/index.jsx";
import BeneficiaryTransactionStepAdditionalDetails from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionCreate/BeneficiaryTransactionStepAdditionalDetails/index.jsx";
import BeneficiaryTransactionStepAmount from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionCreate/BeneficiaryTransactionStepAmount/index.jsx";
import BeneficiaryTransactionStepConfirm from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionCreate/BeneficiaryTransactionStepConfirm/index.jsx";
import BeneficiaryRecreateTxnStepAdditionalDetails from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionRecreate/BeneficiaryRecreateTxnStepAdditionalDetails";
import BeneficiaryRecreateTxnStepAmountPaymentMethod from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionRecreate/BeneficiaryRecreateTxnStepAmountPaymentMethod";
import BeneficiaryRecreateTxnStepSourceDestination from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionRecreate/BeneficiaryRecreateTxnStepSourceDestination";
import { getAllBeneficiaryAccounts } from "../../../../redux/features/accounts/beneficiaryAccount/index.js";
import { ownerAccountsViewAll } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import {
  bankLookUp,
  getAllCategories,
  panLookUp,
  uploadFile,
} from "../../../../redux/features/sharedResources/sharedResources";
import {
  beneficiaryTransactionsCreate,
  beneficiaryTransactionsDetailsById,
  beneficiaryTransactionsRecreate,
  beneficiaryTransactionsViewAll,
} from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../utils/bankingHours";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  PaymentMethodAnimationConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import Validation from "../../../../utils/validation.js";
import BeneficiaryTransactionViewall from "../BeneficiaryTransactionViewall/index.jsx";
import "./index.css";

const RTGS_MIN_AMOUNT = 200000;

const BeneficiaryTransactionCreate = () => {
  const [refactoredTxn] = useState(() => {
    const storedTxn = sessionStorage.getItem("recreate_ben");

    return storedTxn ? JSON.parse(storedTxn) : null;
  });

  const steps = [
    globalText?.SOURCE_AND_DESTINATION_ACCOUNT,
    globalText?.CATEGORY_AND_LABELS,
    globalText?.AMOUNT,
    globalText?.CONFIRM_AND_CREATE,
  ];

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const scrollIt = useRef(null);
  const stepperHeightRef = useRef(null);
  const prevBeneAccountRef = useRef(null);
  const hasAutoFillInteracted = useRef(false);
  const currentAccountDetails = location?.state;
  const [remPan, setRemPan] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [endDate, setEndDate] = useState({});
  const [isNeft, setIsNeft] = useState(true);
  const [isRtgs, setIsRtgs] = useState(false);
  const [timeData, setTimeData] = useState({});
  const [openBar, setOpenBar] = useState(false);
  const [startDate, setStartDate] = useState({});
  const [mapingCat, setMapingCat] = useState("");
  const [autoFill, setAutoFill] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [hyperLinks, setHyperLinks] = useState({});
  const [mapingData, setMapingData] = useState("");
  const [quantities, setQuantities] = useState({});
  const [direction, setDirection] = useState(null);
  const [catSelect, setCatSelect] = useState(false);
  const [openOwner, setOpenOwner] = useState(false);
  const [remAccount, setRemAccount] = useState("");
  const [activeType, setActiveType] = useState("pan");
  const [txnLoading, settxnLoading] = useState(false);
  const [stepperHeight, setStepperHeight] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [previewImages, setPreviewImages] = useState({});
  const [selectedValue, setSelectedValue] = useState({});
  const [reCreateFlow, setReCreateFlow] = useState(false);
  const [sourceSelect, setSourceSelect] = useState(false);
  const [additionalData, setAdditionalData] = useState({});
  const [accountSelect, setAccountSelect] = useState(false);
  const [isNextEnabled, setIsNextEnabled] = useState(false);
  const [isHoverEnabled, setIsHoverEnabled] = useState(true);
  const [isAmountCopied, setIsAmountCopied] = useState(false);
  const [isConfidential, setIsConfidential] = useState(false);
  const [slideAnimation, setSlideAnimation] = useState(false);
  const [havePANAssociate, setHavePANAssociate] = useState(0);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [haveBankAssociate, setHaveBankAssociate] = useState(0);
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showSimilarModal, setShowSimilarModal] = useState(false);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [refactorDisplayStep, setRefactorDisplayStep] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);
  const [similarTransaction, setSimilarTransaction] = useState(false);
  const [isAutoFilledSource, setIsAutoFilledSource] = useState(false);
  const [transactionDisable, setTransactionDisable] = useState(false);
  const [isStepper, setIsStepper] = useState(window.innerWidth <= 800);
  const [showConfirmLeavePopup, setShowConfirmLeavePopup] = useState(false);
  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);
  const [hasUserSelectedAccount, setHasUserSelectedAccount] = useState(
    !!currentAccountDetails?.id,
  );
  const [initialRefactorAdditionalDetail, setInitialRefactorAdditionalDetail] =
    useState({});
  const [copyData, setCopyData] = useState({
    title: "",
    data_type: "",
    value: "",
  });
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: currentAccountDetails?.name
      ? currentAccountDetails.name
      : "",
    beneAccountId: currentAccountDetails?.id ? currentAccountDetails?.id : "",
    bankAccountIFSC: currentAccountDetails?.ifsc_code
      ? currentAccountDetails?.ifsc_code
      : "",
    bankAccountNo: currentAccountDetails?.bank_acc_no
      ? currentAccountDetails?.bank_acc_no
      : "",
    categoryIds: currentAccountDetails?.categoryIds
      ? currentAccountDetails?.categoryIds
      : "",
    amount: "",
    settleType: "",
    bankLogo: currentAccountDetails?.bank_name
      ? currentAccountDetails?.bank_name
      : "",
    pan: currentAccountDetails?.pan ? currentAccountDetails?.pan : "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: 0,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountInWords: "",
    labels: currentAccountDetails?.labels ? currentAccountDetails?.labels : [],
    ownerLabels: [],
  });
  const [category, setCategory] = useState(
    txnPayLoad?.categoryIds ? txnPayLoad?.categoryIds : [],
  );

  const [accountNumber, setAccountNumber] = useState(
    txnPayLoad?.bankAccountNo ? txnPayLoad.bankAccountNo : "",
  );

  const [IFSC, setIFSC] = useState(
    txnPayLoad?.bankAccountIFSC ? txnPayLoad.bankAccountIFSC : "",
  );

  const isWindow = window.innerWidth >= ScreenSizeConfiguration?.mobileScreen;
  const animationClassS =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };

  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );
  const { panLookupData, bankLookupData } = useSelector(
    (state) => state.sharedResources,
  );

  const {
    beneficiaryTransactionsDetailsLoading,
    beneficiaryTransactionsDetailsData,
  } = useSelector((state) => state?.beneficiaryTransactions);

  const txnData = beneficiaryTransactionsDetailsData?.transaction?.[0];

  const txnCategoryId = txnData?.category_id?.category_id;
  const txnCategoryName = txnData?.category_id?.category_name;

  const isOutsideBankingHoursNow = isOutsideBankingHours();

  const shouldShowBankingHoursAlert =
    isOutsideBankingHoursNow &&
    [
      GlobalConfiguration.lengthCheckZero,
      GlobalConfiguration.lengthCheckThree,
    ].includes(activeStep);

  const shouldShowAssociatedAccounts =
    (haveBankAssociate > GlobalConfiguration?.lengthCheckOne ||
      havePANAssociate > GlobalConfiguration?.lengthCheckOne) &&
    accountNumber &&
    IFSC;

  const allLabels = [
    ...new Set([
      ...(txnPayLoad?.ownerLabels || []),
      ...(txnPayLoad?.labels || []),
    ]),
  ];

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOwnerSelection = (
    name,
    acc,
    ifsc,
    logo,
    ownerId,
    balance,
    lastFetched,
  ) => {
    setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,
      ownerAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
      ownerBankBalance: balance,
      ownerLastUpdated: lastFetched,
    }));
  };

  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    categoryIds,
    panNo,
    beneAccountId,
    labels,
  ) => {
    const categoriesArray =
      categoryIds?.map((c) => c.category_id ?? c.id) || [];
    setCategory(categoriesArray);
    setAccountNumber(accountNumber);
    setIFSC(ifsc);

    const isRecreateFlow = mapingData === "renderData";

    const isAccountChanged =
      txnPayLoad?.beneAccountId && txnPayLoad?.beneAccountId !== beneAccountId;

    if (!isRecreateFlow || isAccountChanged) {
      setSelectedCategory(null);
      setCatSelect(false);
      setInitialRefactorAdditionalDetail({});
    }

    setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      labels: labels,
      selectedCategory:
        isRecreateFlow && !isAccountChanged ? selectedCategory : null,
      amountWords: "",
      mergeCategory: null,
    }));
    setHasUserSelectedAccount(true);
    handleCloseModal();

    if (txnData?.beneficiary_accounts?.[0]?.id !== beneAccountId) {
      setAccountSelect(false);
    }
  };

  const handleKeyDown = (event) => {
    if (
      event.target.tagName === "INPUT" ||
      event.target.tagName === "TEXTAREA"
    ) {
      if (event.key === "Tab") {
        event.preventDefault();
      }
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab"
    ) {
      event.preventDefault();
    }
  };

  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };

  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;
    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      setTxnPayLoad((prev) => ({
        ...prev,
        amount: "",
        amountInWords: "",
      }));
      return;
    }

    if (trimmedValue[0] === "0") return;

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");

    if (
      name !== "amount" ||
      (!allowedValue(numericValue) && numericValue.length)
    ) {
      return;
    }
    const amountNumber = parseFloat(numericValue);
    const amountInWords = AmountToWords(amountNumber);
    const adjustedAmountWords =
      amountNumber > GlobalConfiguration?.lengthCheckZero &&
      amountNumber <= GlobalConfiguration?.lengthCheckOne
        ? amountInWords.replace("rupees", "rupee")
        : amountInWords;

    const settleType = amountNumber > 200000 ? "rtgs" : "neft";

    const paymentMethodChanged =
      (settleType === "neft" && isRtgs) || (settleType === "rtgs" && isNeft);

    if (paymentMethodChanged) {
      setSlideAnimation(true);

      setTimeout(
        () => setSlideAnimation(false),
        PaymentMethodAnimationConfiguration.slideDuration,
      );
    }
    setIsNeft(settleType === "neft");
    setIsRtgs(settleType === "rtgs");
    setTxnPayLoad((prev) => ({
      ...prev,
      amount: numericValue,
      amountInWords: adjustedAmountWords,
      settleType,
    }));
  };

  const handleNeftClick = () => {
    if (Number(txnPayLoad?.amount) > RTGS_MIN_AMOUNT) {
      CommonToast({
        text: (
          <>
            Transaction amount should be less than <br /> INR 2 lakhs.
          </>
        ),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
  };

  const handleRtgsClick = () => {
    if (Number(txnPayLoad?.amount) <= RTGS_MIN_AMOUNT) {
      CommonToast({
        text: (
          <>
            Transaction amount should be more than <br /> INR 2 lakhs.
          </>
        ),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
  };

  const handleCreateTransaction = async () => {
    if (transactionDisable) return;
    setTransactionDisable(true);

    let haveImage = txnPayLoad?.mergeCategory?.some((val) => {
      return val?.data_type === "upload" && val?.value !== "Not given";
    });

    let storeData;

    let add = 0;

    if (haveImage) {
      const responseUpload = await Promise.all(
        Object.values(uploadedFiles).map((file) =>
          dispatch(uploadFile({ file: file })),
        ),
      );
      if (responseUpload) {
        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData[val?.name]) {
            const dataValue = additionalData[val?.name];
            if (val?.data_type === "numeric") {
              return {
                ...val,
                value: Number(dataValue),
              };
            } else if (val?.data_type === "upload") {
              const { description, ...rest } = val;
              return { ...rest, value: responseUpload[add++]?.payload };
            } else if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            } else {
              return { ...val, value: dataValue };
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }
          return val;
        });
      }
    } else {
      storeData = selectedCategory?.configuration?.data?.map((val) => {
        if (additionalData[val?.name]) {
          const dataValue = additionalData[val?.name];
          if (val?.data_type === "numeric") {
            return {
              ...val,
              value: Number(dataValue),
            };
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest, value: dataValue };
          } else {
            return { ...val, value: dataValue };
          }
        } else if (val?.data_type === "toggle") {
          const { description, ...rest } = val;
          return { ...rest };
        }
        return val;
      });
    }

    const beneficiaryTxnData = {
      amount: txnPayLoad.amount,
      owner_account_id: txnPayLoad.ownerId,
      beneficiary_account_id: txnPayLoad.beneAccountId,
      category_id: selectedCategory?.id,
      additional_data: {
        data: storeData,
      },
      payment_method: txnPayLoad.settleType.toUpperCase(),
      confidential_transaction: isConfidential,
      labels: [...(txnPayLoad.labels || []), ...(txnPayLoad.ownerLabels || [])],
    };

    const response = await dispatch(
      beneficiaryTransactionsCreate({
        beneficiaryTxnData,
      }),
    );

    if (beneficiaryTransactionsCreate.fulfilled.match(response)) {
      const transactionId = response.payload?.transaction?.[0]?.txn_id;

      if (refactoredTxn?.type === "refactorFlow") {
        await dispatch(
          beneficiaryTransactionsRecreate({
            id: refactoredTxn?.txn_id,
          }),
        );
      }
      navigate(
        `/beneficiary_transaction_dashboard/create_beneficiary_transaction/success/${transactionId}`,
      );
    } else {
      navigate(
        "/beneficiary_transaction_dashboard/create_beneficiary_transaction/failed",
      );
    }
    setTransactionDisable(false);
  };

  const queryParams = () => ({
    page_no: GlobalConfiguration?.lengthCheckOne,
    page_item_count: PaginationConfiguration?.paginationSmall,
    amount: txnPayLoad?.amount,
    payment_method: txnPayLoad?.settleType?.toUpperCase(),
    beneficiary_account_id: txnPayLoad?.beneAccountId,
    owner_account_id: txnPayLoad?.ownerId,
    confidential_transaction: isConfidential
      ? "Show only confidential"
      : "Hide confidential",
  });

  const handleCopyLabels = (prevLabels) => {
    const currentOwnerLabels = txnPayLoad?.ownerLabels || [];

    const newOwnerLabels = prevLabels.filter((l) =>
      currentOwnerLabels.includes(l),
    );
    const newOtherLabels = prevLabels.filter(
      (l) => !currentOwnerLabels.includes(l),
    );

    setTxnPayLoad((prev) => ({
      ...prev,
      labels: newOtherLabels,
      ownerLabels: newOwnerLabels,
    }));
  };

  const handleNext = async () => {
    hasAutoFillInteracted.current = false;
    if (isButtonDisabled) return;
    setButtonDisabled(true);
    try {
      if (activeStep === GlobalConfiguration.lengthCheckTwo) {
        settxnLoading(true);
        const res = await dispatch(
          beneficiaryTransactionsViewAll(queryParams()),
        );
        const hasDuplicates =
          res?.payload?.transactions?.length >
          GlobalConfiguration?.lengthCheckZero;

        setSimilarTransaction(hasDuplicates);

        if (hasDuplicates) {
          toast.dismiss();
          CommonToast({
            text: "Few issues found click check to view.",
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
          });
        }
        setActiveStep((prev) => prev + GlobalConfiguration.lengthCheckOne);

        setDirection("next");
        settxnLoading(false);
        setRemoveClassName(false);
        setAutoFill(false);
        setTimeout(() => {
          setRemoveClassName(true);
        }, IntervalConfiguration?.intervalSemiMid);

        setOpenBar(false);
      } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
        if (similarTransaction) {
          setShowSimilarModal(true);
        } else {
          await handleCreateTransaction();
        }
      } else {
        setActiveStep((prev) => prev + GlobalConfiguration.lengthCheckOne);

        setDirection("next");

        setRemoveClassName(false);
        setAutoFill(false);
        setTimeout(() => {
          setRemoveClassName(true);
        }, IntervalConfiguration?.intervalSemiMid);

        setTimeout(() => {
          setButtonDisabled(false);
        }, IntervalConfiguration?.intervalSmaller);
        setOpenBar(false);
      }
    } finally {
      setButtonDisabled(false);
    }
  };

  const isFormDirty = () => {
    return (
      activeStep > GlobalConfiguration?.lengthCheckZero ||
      txnPayLoad.ownerId !== null ||
      txnPayLoad.beneAccountId !== "" ||
      txnPayLoad.categoryIds !== "" ||
      txnPayLoad.categoryIds?.length > 0
    );
  };

  const handleBack = () => {
    hasAutoFillInteracted.current = false;
    if (isButtonDisabled) return;

    if (activeStep === 0) {
      if (isFormDirty()) {
        setShowConfirmLeavePopup(true);
      } else {
        navigate(-1);
      }
      return;
    }
    setButtonDisabled(true);
    try {
      setActiveStep((prev) => (prev ? prev - 1 : 0));

      setDirection("previous");

      setAutoFill(false);
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration?.intervalSemiMid);
      setOpenBar(false);
    } finally {
      setButtonDisabled(false);
    }
  };

  const isReminderFlow = location?.state?.flowType === "ReminderFlow";

  const commonStepperConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--text-disabled)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextEnableBgColor: "var(--text-primary)",
    nextDisableBgColor: "var(--text-disabled)",
    nextEnableTextColor: "var(--primary-bg)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const reminderText = isReminderFlow
    ? `Reminder remark: ${location?.state?.txnDetails?.reminderRemark || "-"}`
    : "";

  const dataArray = steps.map((stepLabel, index) => {
    const isLastStep = index === steps.length - 1;
    const isTxnLoading = isLastStep && transactionDisable;
    return {
      ...commonStepperConfig,
      previousText:
        index === GlobalConfiguration.lengthCheckZero ? "Cancel" : "Previous",
      previousIsDisabled: isTxnLoading,
      nextText: isLastStep ? (similarTransaction ? "Check" : "Create") : "Next",
      nextLoaderNeeded: isLastStep,
      nextIsLoading: isTxnLoading,
      nextIsEnabled: isLastStep
        ? !transactionDisable
        : isNextEnabled && !isButtonDisabled,
      nextEnableBgColor: isLastStep
        ? similarTransaction
          ? "var(--emphasis)"
          : "var(--positive-act)"
        : "var(--text-primary)",
      nextDisableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--primary-bg)",
      nextDisableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--text-primary)",
      stepperText: stepLabel,
      extraInfoSubText: reminderText,
      extraInfoShow: isReminderFlow,
    };
  });

  const renderCreateTxn = () => {
    switch (activeStep) {
      case 0:
        return (
          <BeneficiaryTransactionStepAccount
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            isConfidential={isConfidential}
            setIsConfidential={setIsConfidential}
            shouldShowAssociatedAccounts={shouldShowAssociatedAccounts}
            activeType={activeType}
            setActiveType={setActiveType}
            remPan={remPan}
            setRemPan={setRemPan}
            remAccount={remAccount}
            setRemAccount={setRemAccount}
            remIFSC={remIFSC}
            setRemIFSC={setRemIFSC}
            handleOwnerSelection={handleOwnerSelection}
            handleAccountSelection={handleAccountSelection}
          />
        );
      case 1:
        return (
          <BeneficiaryTransactionStepAdditionalDetails
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            quantities={quantities}
            setQuantities={setQuantities}
            hyperLink={hyperLinks}
            setHyperLink={setHyperLinks}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
            timeData={timeData}
            setTimeData={setTimeData}
            copyData={copyData}
            setCopyData={setCopyData}
            initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
            setInitialRefactorAdditionalDetail={
              setInitialRefactorAdditionalDetail
            }
            beneAccountId={txnPayLoad?.beneAccountId}
            categories={categories}
            category={category}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
          />
        );
      case 2:
        return (
          <BeneficiaryTransactionStepAmount
            txnPayLoad={txnPayLoad}
            isNeft={isNeft}
            isRtgs={isRtgs}
            copyData={copyData}
            setCopyData={setCopyData}
            txnLoading={txnLoading}
            slideAnimation={slideAnimation}
            handleNeftClick={handleNeftClick}
            handleRtgsClick={handleRtgsClick}
            handleAmountChange={handleAmountChange}
          />
        );
      case 3:
        return (
          <BeneficiaryTransactionStepConfirm
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            isConfidential={isConfidential}
            previewImages={previewImages}
            allLabels={allLabels}
          />
        );
      default:
        return null;
    }
  };

  const renderRefactorSteps = (stepOverride) => {
    const step = stepOverride ?? activeStep;
    switch (step) {
      case 0:
        return (
          <BeneficiaryRecreateTxnStepSourceDestination
            setAccountSelect={setAccountSelect}
            setSourceSelect={setSourceSelect}
            setMapingData={setMapingData}
            txnData={txnData}
            txnPayload={txnPayLoad}
            beneCat={txnData?.category_id}
            setIsConfidential={setIsConfidential}
            isConfidential={isConfidential}
            accountSelect={accountSelect}
            isAutoFilledSource={isAutoFilledSource}
            setIsAutoFilledSource={setIsAutoFilledSource}
          />
        );

      case 1:
        return (
          <BeneficiaryRecreateTxnStepAdditionalDetails
            setCatSelect={setCatSelect}
            beneCat={txnCategoryName}
            beneCatId={txnCategoryId}
            setMapingCat={setMapingCat}
            selectedCategory={selectedCategory}
            txnPayLoad={txnPayLoad}
            onCopyLabels={handleCopyLabels}
            txnData={txnData}
            beneficiaryTransactionsDetailsData={
              beneficiaryTransactionsDetailsData
            }
            initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
            setInitialRefactorAdditionalDetail={
              setInitialRefactorAdditionalDetail
            }
            setSelectedValue={setSelectedValue}
            setSelectedValueMonth={setSelectedValueMonth}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setTimeData={setTimeData}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            setQuantities={setQuantities}
            assignedCategories={category}
            categories={categories}
          />
        );

      case 2:
        return (
          <BeneficiaryRecreateTxnStepAmountPaymentMethod
            txnData={txnData}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            setIsNeft={setIsNeft}
            setIsRtgs={setIsRtgs}
            isAmountCopied={isAmountCopied}
            setIsAmountCopied={setIsAmountCopied}
            copyToClipboard={copyToClipboard}
          />
        );

      default:
        return null;
    }
  };

  let operBarValidation = useCallback(() => {
    return (
      (!isModalOpen && activeStep === 0) ||
      (!openOwner && activeStep === 2) ||
      activeStep === 1 ||
      activeStep === 3
    );
  }, [openOwner, isModalOpen, activeStep]);

  useEffect(() => {
    if (txnData?.owner_account_bank_acc_no) {
      dispatch(
        ownerAccountsViewAll({
          bank_account_no: txnData?.owner_account_bank_acc_no,
        }),
      );
    }
  }, [activeStep, txnData?.owner_account_bank_acc_no, dispatch]);

  useEffect(() => {
    if (mapingCat !== "renderCat" || !catSelect) return;

    if (!txnCategoryId) {
      setMapingCat(null);
      setCatSelect(false);
      return;
    }

    const assignedCategories = category || [];

    const categoryData = categories?.find(
      (cat) => String(cat.id) === String(txnCategoryId),
    );
    const isAssigned =
      !!categoryData &&
      assignedCategories.some((id) => String(id) === String(categoryData.id));

    if (!categoryData || !isAssigned || categoryData?.active !== "Y") {
      setSelectedCategory(null);
      setTxnPayLoad((prev) => ({
        ...prev,
        selectedCategory: null,
        mergeCategory: null,
      }));
      setMapingCat(null);
      setCatSelect(false);
      return;
    }

    setSelectedCategory(categoryData);
    setTxnPayLoad((prev) => ({
      ...prev,
      selectedCategory: categoryData,
      mergeCategory: categoryData?.configuration?.data || [],
    }));
    setAdditionalData({});
    setSelectedValue({ from: "Select", to: "Select" });
    setStartDate({});
    setEndDate({});
    setHyperLinks({});
    setPreviewImages({});
    setUploadedFiles({});
    setTimeData({});
    setQuantities({});
    setSelectedValueMonth({});

    setMapingCat(null);
    setCatSelect(false);
  }, [mapingCat, catSelect]);

  const copyToClipboard = (title, data_type, value) => {
    if (navigator?.clipboard?.writeText !== undefined) {
      navigator.clipboard
        .writeText(value?.toString())
        .then(() => {
          setCopyData({ title, data_type, value });
        })
        .catch((err) => {
          console.error("Clipboard copy failed:", err);
        });
    }
  };

  useEffect(() => {
    if (Number(txnData?.amount) === Number(txnPayLoad?.amount)) {
      setIsAmountCopied(true);
    } else {
      setIsAmountCopied(false);
    }
  }, [txnData?.amount, txnPayLoad?.amount]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 800) {
        setReCreateFlow(false);
      }
    };
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!refactoredTxn?.txn_id) {
      return;
    }

    dispatch(
      beneficiaryTransactionsDetailsById({
        id: refactoredTxn.txn_id,
      }),
    );
  }, [dispatch, refactoredTxn?.txn_id]);

  useEffect(() => {
    if (!beneficiaryTransactionsDetailsLoading) {
      const initalData = {};

      const additionalData =
        beneficiaryTransactionsDetailsData?.transaction?.[0]?.additional_data
          ?.data || [];

      additionalData?.forEach(({ name, value, data_type }) => {
        if (
          value !== null &&
          value !== "" &&
          value !== undefined &&
          value?.length !== GlobalConfiguration?.lengthCheckZero
        ) {
          if (
            data_type === "hyperlink" ||
            data_type === "string" ||
            data_type === "numeric"
          ) {
            initalData[name] = {
              isCopyClick: false,
              isPaste: {},
              name: name,
              data: value,
            };
          } else {
            initalData[name] = {
              isCopyDirect: false,
              name: name,
              data: value,
            };
          }
        }
      });
      setInitialRefactorAdditionalDetail(initalData);
    }
  }, [
    beneficiaryTransactionsDetailsData,
    beneficiaryTransactionsDetailsLoading,
  ]);

  useEffect(() => {
    if (mapingData === "renderData" && accountSelect) {
      const accNo = txnData?.beneficiary_account_bank_acc_no;
      const ifsc = txnData?.beneficiary_account_ifsc_code;

      if (!accNo || !ifsc) {
        setMapingData(null);
        setSourceSelect?.(false);
        return;
      }

      dispatch(
        getAllBeneficiaryAccounts({
          bank_account_no: accNo,
          ifsc: ifsc?.toUpperCase(),
        }),
      ).then((res) => {
        const account = res?.payload?.beneficiary_accounts?.[0];
        handleAccountSelection(
          account?.name ?? txnData?.beneficiary_account_name,
          account?.bank_acc_no ?? accNo,
          account?.ifsc_code ?? ifsc,
          account?.bank_name ?? txnData?.beneficiary_account_bank_name,
          account?.category_ids,
          account?.pan_no ?? txnData?.beneficiary_account_pan,
          account?.id ?? txnData?.beneficiary_account_id,
          account?.labels ?? txnData?.labels,
        );

        setMapingData(null);
        setSourceSelect?.(false);
      });
    }
  }, [mapingData, accountSelect]);

  useEffect(() => {
    if (mapingData === "renderSource" && sourceSelect) {
      handleOwnerSelection(
        txnData?.owner_account_bank_name,
        txnData?.owner_account_bank_acc_no,
        txnData?.owner_account_ifsc_code,
        txnData?.owner_account_bank_name,
        txnData?.owner_account_id,
        txnData?.owner_account_balance,
        txnData?.owner_account_balance_last_fetched_at_in_words,
      );

      setMapingData(null);
      setSourceSelect(false);
    }
  }, [mapingData, sourceSelect]);

  useEffect(() => {
    setHaveBankAssociate(bankLookupData?.total_count || 0);
    setHavePANAssociate(panLookupData?.total_count || 0);
  }, [panLookupData, bankLookupData, dispatch]);

  useEffect(() => {
    const configData = txnPayLoad?.selectedCategory?.configuration?.data || [];
    const mergeCategory = txnPayLoad?.mergeCategory || [];

    const mandatoryFields = configData.filter((v) => v?.mandatory === "Y");

    const filledMandatoryFields = mergeCategory.filter((v) => {
      if (v?.mandatory !== "Y") return false;

      switch (v?.data_type) {
        case "multi_select_list":
          return Array.isArray(v.value) && v.value.length > 0;

        case "from_year_to_year": {
          const from = v?.value?.from;
          const to = v?.value?.to;

          const bothEmpty = !from && !to;
          const bothFilled = from && to;

          if (bothEmpty && v?.mandatory !== "Y") {
            return true;
          }

          return bothFilled;
        }

        case "date_range":
          return v?.value?.start_date && v?.value?.end_date;

        case "toggle":
          return v?.value === true;

        default:
          return v?.value !== "" && v?.value !== undefined;
      }
    });

    const isMandatoryFieldsFilled =
      mandatoryFields.length === filledMandatoryFields.length;

    const isHyperlinkHave = mergeCategory.some(
      (v) => v?.data_type === "hyperlink",
    );

    const isHyperlinkValid = mergeCategory
      .filter((v) => v?.data_type === "hyperlink" && v?.value !== "")
      .every((v) => isValidHttpUrl(v?.value));

    const isAmountValid = txnPayLoad?.amount > 0;

    const isRtgsSelected = txnPayLoad?.settleType === "rtgs";
    const isRtgsValid = !isRtgsSelected || txnPayLoad?.amount >= 200000;

    const isSettleTypeValid =
      txnPayLoad?.settleType &&
      !(
        (txnPayLoad?.settleType === "rtgs" && txnPayLoad?.amount <= 200000) ||
        (txnPayLoad?.settleType === "neft" && txnPayLoad?.amount > 200000)
      );

    let isStepValid = false;

    switch (activeStep) {
      case 0:
        isStepValid = !!txnPayLoad?.ownerId && !!txnPayLoad?.beneAccountId;
        break;

      case 1:
        isStepValid =
          !!txnPayLoad?.selectedCategory &&
          isMandatoryFieldsFilled &&
          (!isHyperlinkHave || isHyperlinkValid);
        break;

      case 2:
        isStepValid = isAmountValid && isRtgsValid && isSettleTypeValid;
        break;

      case 3:
        isStepValid = true;
        break;

      default:
        isStepValid = false;
    }
    setIsNextEnabled(isStepValid);
  }, [activeStep, txnPayLoad, hyperLinks]);

  useEffect(() => {
    const labels = sessionStorage.getItem("beneficiaryTxnLabels");

    if (!labels) {
      dispatch(
        beneficiaryTransactionsViewAll({
          page_no: GlobalConfiguration.lengthCheckOne,
          page_item_count: PaginationConfiguration.paginationSmall,
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (
      location?.state?.txnDetails?.reminderAmount &&
      txnPayLoad?.amount === ""
    ) {
      const amount = parseFloat(location.state.txnDetails.reminderAmount);

      let words = AmountToWords(amount) || "";

      if (amount >= 1 && amount <= 9) {
        words = words.replace("rupees", "rupee");
      }

      setTxnPayLoad((prev) => ({
        ...prev,
        amount: amount,
        amountInWords: words,
      }));
    }
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 800;

      setIsMobile(mobile);
      setIsStepper(mobile);

      if (!mobile) {
        setAutoFill(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const { beneAccountId, pan, bankAccountIFSC, bankAccountNo } =
      txnPayLoad || {};

    if (!beneAccountId) return;
    if (!hasUserSelectedAccount) return;
    if (prevBeneAccountRef.current === beneAccountId) {
      return;
    }

    prevBeneAccountRef.current = beneAccountId;

    dispatch(getAllCategories({ bene_account_id: beneAccountId }));

    if (pan) {
      dispatch(panLookUp({ pan_number: pan }));
    }

    if (bankAccountIFSC && bankAccountNo) {
      dispatch(
        bankLookUp({
          ifsc: bankAccountIFSC,
          bank_account_no: bankAccountNo,
        }),
      );
    }
  }, [txnPayLoad?.beneAccountId, hasUserSelectedAccount]);

  useEffect(() => {
    if (autoFill) {
      setIsHoverEnabled(false);
    } else {
      const timer = setTimeout(() => {
        setIsHoverEnabled(true);
      }, 600);

      return () => clearTimeout(timer);
    }
  }, [autoFill]);

  useEffect(() => {
    if (scrollIt.current) {
      scrollIt.current.scrollTop = 0;
    }
  }, [activeStep]);

  useEffect(() => {
    const updateHeight = () => {
      setStepperHeight(
        stepperHeightRef?.current?.firstElementChild?.offsetHeight,
      );
    };

    updateHeight();

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [stepperHeight]);

  return (
    <>
      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}

      {showSimilarModal && (
        <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle={"Similar transactions found"}
            headersubtext={
              "Transactions with similar details have already been created. Proceeding will result in a duplicate transaction."
            }
            isHeaderImgNeed={true}
            ShowIcon={ICONS.ALERT}
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => setShowSimilarModal(false)}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            confirmbtnrequired={true}
            isbottomSectionneed={true}
            bottomHeaderTextNeed={true}
            btnText="Proceed with caution"
            handleFunction={() => {
              setShowSimilarModal(false);
              handleCreateTransaction();
            }}
            bottomHeaderText={"Proceed with creating this transaction?"}
          >
            <BeneficiaryTransactionViewall
              bene_account_name={txnPayLoad?.bankAccountName || "NA"}
              bene_account_id={txnPayLoad?.beneAccountId || null}
              bene_account_confidential={txnPayLoad?.beneAccountId || null}
              onClose={() => {
                setShowSimilarModal(false);
              }}
              queryParams={queryParams()}
              similarTxnType={"similarTxn"}
              popup={"modalType"}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showConfirmLeavePopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-top-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-lg"
            subtext={globalText?.EXIT_CURRENT_FLOW_NOTE}
            btnOneText={globalText?.STAY}
            btnOneHandleFunction={() => setShowConfirmLeavePopup(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoHandleFunction={() => {
              setShowConfirmLeavePopup(false);
              navigate(-1);
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
          />
        </div>
      )}

      <div
        className="w-width-full flex items-center flex-col bg-primary-bg overflow-y-auto"
        style={{
          height:
            openOwner || isModalOpen
              ? "var(--height-full)"
              : "var(--full-height)",
        }}
      >
        <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-transparent bg-primary-nav flex-shrink-0"></div>
        <div
          style={
            isWindow && currentAccountDetails?.flowType === "ReminderFlow"
              ? { minHeight: stepperHeight }
              : {}
          }
          className={`fixed Qsmd:relative left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto Qsmd:bg-transparent shrink-0
         ${location?.state?.flowType === "ReminderFlow" ? "Qsmd:min-h-topnav-bottom-height min-h-stepper-moble-height" : refactoredTxn?.type === "refactorFlow" ? "Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-moble-height Qsmd:bg-transparent" : "Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-moble-height Qsmd:bg-transparent"}`}
        >
          {location?.state?.flowType === "ReminderFlow" && activeStep !== 3 && (
            <div
              className={`${openBar && isStepper ? "none" : ""} fixed stepper_Div w-width-full  Qsmd:hidden`}
              style={{
                width: isMobile ? "var(--full-width)" : "",
              }}
            >
              <div className="reminder-bene-flow-container w-width-full bg-primary-card Qsmd:relative z-z-index-base Qsmd:z-z-index-header rounded-br-border-radius-md rounded-bl-border-radius-md fixed">
                <div
                  className={`transition-[max-height] duration-animation-medium ease-in-out overflow-hidden ${
                    openBar
                      ? "max-h-max-height-top-slider opacity-base-opacity pointer-events-auto z-z-index-content"
                      : "max-h-0 opacity-opacity-none pointer-events-none z-z-index-base"
                  }`}
                >
                  <section className="reminder-flow-message-container-bene overflow-x-hidden">
                    <span className="text-font-xs text-text-primary font-sans Qsmd:hidden">
                      Reminder remark
                    </span>
                    <p className="text-font-xs text-text-primary font-sans font-normal pt-padding-sm Qsmd:pt-padding-base break-words">
                      {location?.state?.txnDetails?.reminderRemark}
                    </p>
                  </section>

                  <hr className="hidden w-max-content-width Qsmd:block border border-primary-bg" />
                </div>

                {openBar && (
                  <button
                    className="w-full h-auto flex items-center justify-center bg-text-primary cursor-pointer z-z-index-toast py-padding-sm fixed bottom-bottom-base left-left-base Qsmd:hidden transition-all duration-animation-medium ease-in-out"
                    onClick={() => setOpenBar(false)}
                  >
                    <span className="text-font-md font-sans font-semibold text-primary-card">
                      Back
                    </span>
                  </button>
                )}

                <section
                  className={`w-full Qsmd:p-padding-sm p-padding-md  Qsmd:bg-primary-card flex flex-row Qsmd:justify-center Qsmd:rounded-br-border-radius-md Qsmd:rounded-bl-border-radius-md items-center gap-gap-sm bg-primary-nav-act justify-between z-z-index-base relative bottom-bottom-sm cursor-${
                    operBarValidation() ? "pointer" : ""
                  } hover:${operBarValidation() ? "bg-primary-card" : ""} ${
                    operBarValidation() ? "global-hover-white" : ""
                  }`}
                  onClick={() => {
                    if (operBarValidation()) {
                      setOpenBar(!openBar);
                    }
                  }}
                >
                  <span className="text-font-xs text-text-primary font-sans font-normal">
                    Reminder remark
                  </span>

                  <div className="transition-transform duration-animation-medium ease-in-out">
                    <SVGComponent
                      url={
                        isMobile
                          ? openBar
                            ? ICONS?.ARROW_UP_WHITE
                            : ICONS?.ARROW_RIGHT_WHITE
                          : openBar
                            ? ICONS?.ARROW_UP_WHITE
                            : ICONS?.ARROW_DOWN_WHITE
                      }
                      color="var(--text-primary)"
                      height={"var(--icon-sm)"}
                      width={"var(--icon-sm)"}
                    />
                  </div>
                </section>
              </div>
              <div
                className={`h-stepper-moble-height w-width-full block Qsmd:hidden flex-shrink-0 ${activeStep === 3 ? "" : "bg-primary-nav-act"}`}
              ></div>
            </div>
          )}
          {isStepper &&
            (refactoredTxn?.type === "refactorFlow" || reCreateFlow) &&
            location?.state?.flowType !== "ReminderFlow" && (
              <div className="fixed bottom-bottom-base w-width-full">
                <div
                  style={{
                    display: activeStep === 3 ? "none" : "block",
                  }}
                  className="Refactor_responsive_Bottomdiv w-width-full bg-primary-nav-act p-padding-md relative global-hover-white z-z-index-base cursor-pointer"
                  onClick={() => {
                    setRefactorDisplayStep(activeStep);
                    setReCreateFlow(true);
                  }}
                >
                  <div className="flex justify-between">
                    <p className="font-semibold text-text-primary text-font-xs">
                      Copy or autofill from previous transactions details
                    </p>
                    <div className="">
                      <SVGComponent
                        url={ICONS?.ARROW_RIGHT_WHITE}
                        color={"var(--text-primary)"}
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                        alt="Arrow"
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`h-stepper-moble-height w-width-full block Qsmd:hidden flex-shrink ${activeStep === 3 ? "" : "bg-primary-nav-act"}`}
                ></div>
              </div>
            )}

          {reCreateFlow && (
            <div className="fixed top-top-base left-left-base w-width-full h-height-full bg-primary-bg flex z-[9998] translate-y-0 ease-in-out">
              <div className="flex items-center w-[100vw] bg-primary-nav px-padding-md py-padding-sm rounded-b-border-radius-sm fixed top-top-base z-20">
                <div
                  className="cursor-pointer flex-shrink-0"
                  onClick={() => {
                    setReCreateFlow(false);
                  }}
                >
                  <SVGComponent
                    url={ICONS?.ARROW_LEFT_WHITE}
                    color={"var(--text-primary)"}
                    height={"var(--icon-md)"}
                    width={"var(--icon-md)"}
                    alt="Arrow"
                  />
                </div>
                <div className="flex flex-col gap-gap-xs w-full-width bg-primary-nav pl-padding-md">
                  <div className="text-text-primary text-base font-semibold">
                    Create transaction
                  </div>
                  <p className="text-text-primary text-xs">
                    Previous transaction details
                  </p>
                </div>
              </div>
              <>{renderRefactorSteps(refactorDisplayStep)}</>
            </div>
          )}

          <div
            ref={stepperHeightRef}
            className={` flex-col items-center justify-center ${openBar ? "hidden Qsmd:flex" : "flex"}`}
          >
            <PrimaryStepper
              activeStep={activeStep}
              handleForwardAction={handleNext}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
        </div>
        {(refactoredTxn?.type === "refactorFlow" || reCreateFlow) &&
          location?.state?.flowType !== "ReminderFlow" && (
            <div
              className={`Qsmd:block hidden w-width-full rounded-b-border-radius-md lg:max-w-tab-width-normal relative group top-[calc(var(--negative-global-var)*var(--padding-md))] ${refactoredTxn?.type === "refactorFlow" ? "Qsmd:mb-[calc(var(--negative-global-var)*var(--margin-md))]" : ""}`}
            >
              <div className="lg:h-stepper-header qmd:block hidden"></div>
              {refactoredTxn?.type === "refactorFlow" && (
                <div
                  className={`Qmd:block hidden relative w-width-full py-padding-sm bg-primary-card max-w-tab-width-normal z-z-index-base ${isHoverEnabled ? "group-hover:bg-primary-nav-act" : ""} ${activeStep === 3 ? "rounded-b-border-radius-md" : ""}`}
                ></div>
              )}
              <div
                className={`w-width-full bg-primary-card relative lg:max-w-tab-width-normal rounded-b-border-radius-md justify-center
                ${refactoredTxn?.type === "refactorFlow" ? "mt-margin-base" : "Qmd:mt-margin-base"} ${isMobile || activeStep === 3 ? "hidden" : "flex"}
                ${
                  autoFill
                    ? "h-auto"
                    : refactoredTxn?.type !== "refactorFlow"
                      ? "h-height-base"
                      : ""
                }`}
              >
                <div
                  className={`flex w-width-full ${autoFill ? "items-end" : "items-center pb-padding-base"} ${refactoredTxn?.type !== "refactorFlow" ? "hidden" : ""}`}
                >
                  <div className="flex flex-col w-width-full">
                    <div
                      className={`flex w-width-full justify-center ${refactorDisplayStep === GlobalConfiguration?.lengthCheckOne ? "pl-padding-md" : "px-padding-md"}`}
                    >
                      <div
                        className={`autofill-wrapper w-width-full !hidden Qmd:!flex ${
                          !hasAutoFillInteracted.current
                            ? ""
                            : autoFill
                              ? "open-wrap"
                              : "close-wrap"
                        }`}
                        onAnimationEnd={() => {
                          if (!autoFill) {
                            setRefactorDisplayStep(activeStep);
                          }
                        }}
                      >
                        {renderRefactorSteps(refactorDisplayStep)}
                      </div>
                    </div>
                    {autoFill && (
                      <div className="border border-primary-bg mx-margin-md"></div>
                    )}
                    {beneficiaryTransactionsDetailsLoading ? (
                      <div className="w-width-full flex justify-center relative global-hover-white z-z-index-base py-padding-sm rounded-b-border-radius-md">
                        <Loader
                          height="var(--loader-sm)"
                          width="var(--loader-sm)"
                        />
                      </div>
                    ) : (
                      <div
                        className="flex items-center justify-center gap-gap-xs py-padding-sm rounded-b-border-radius-md relative global-hover-white z-z-index-base cursor-pointer"
                        onClick={() => {
                          hasAutoFillInteracted.current = true;
                          if (!autoFill) {
                            setRefactorDisplayStep(activeStep);
                          }
                          setAutoFill(!autoFill);
                        }}
                      >
                        <p className="text-text-primary text-sm mr-margin-xs cursor-pointer">
                          Copy or autofill from previous transactions details
                        </p>

                        <div className="">
                          <SVGComponent
                            url={
                              autoFill
                                ? ICONS?.ARROW_UP_WHITE
                                : ICONS?.ARROW_DOWN_WHITE
                            }
                            alt="auto fill"
                            color={"var(--text-primary)"}
                            height={"var(--icon-sm)"}
                            width={"var(--icon-sm)"}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        <div className="fixed top-top-base left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
          <TopNavComponent
            topNavHeader="Beneficiary transaction"
            topNavSubText={
              reCreateFlow
                ? "Previous transaction details"
                : steps[activeStep] || ""
            }
            isFormattingNotRequired
          />
        </div>
        <div className="h-loader-lg Qsmd:hidden block flex-shrink-0"></div>
        <div className="overflow-hidden h-full flex flex-col items-center relative w-width-full">
          <div
            ref={scrollIt}
            className={`w-width-full h-height-full mb-margin-base overflow-y-auto ${
              activeStep === 0 && direction === "next"
                ? ""
                : removeClassName === true
                  ? ""
                  : animationClassS
            }`}
            style={{ scrollbarWidth: "none" }}
          >
            {shouldShowBankingHoursAlert && (
              <div className="max-w-tab-width-normal Qlg:mx-auto pt-padding-md Qlg:px-padding-base px-padding-md w-width-full">
                <CommonAlertCard
                  title="Functioning outside banking hours"
                  texts="Transactions will be processed automatically during the next bank working day. Learn more"
                  highlightedText={["Learn more"]}
                  onHighlightedTextClick={(event, index) => {
                    if (index === 0) {
                      setShowBankingHoursPopup(true);
                    }
                  }}
                />
              </div>
            )}

            {renderCreateTxn()}
          </div>
          {refactoredTxn?.type === "refactorFlow" || reCreateFlow ? (
            <div
              className={`${
                activeStep === 3
                  ? "h-stepper-moble-height"
                  : "h-[calc(var(--mobile-create-header)+var(--stepper-moble-height))]"
              } flex-shrink-0 block Qsmd:hidden`}
            />
          ) : (
            <>
              {isReminderFlow &&
              !(
                isReminderFlow &&
                activeStep === GlobalConfiguration.lengthCheckThree
              ) ? (
                <div className="h-mobile-create-header flex-shrink-0 block Qsmd:hidden" />
              ) : (
                <></>
              )}
              <div className="h-stepper-moble-height flex-shrink-0 block Qsmd:hidden" />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default BeneficiaryTransactionCreate;
